export default __webpack_public_path__ + "static/assets/d1b897c44a090b02ae0948c26811e1d5.png";